import gql from 'graphql-tag';
import { SUBSCRIPTIONPLAN_FRAGMENT } from './subscribe';

/** 物流 */
export const LOGISTICS_FRAGMENT = gql`
  fragment Logistics on Logistics {
    id
    logisticCode
    company
    state
    logisticInfo {
      logisticCode
      shipperCode
      traces {
        acceptStation
        acceptTime
      }
      state
    }
    order {
      id
    }
    fulfillment {
      id
      method
    }
  }
`;

/** 订单 - 行 */
export const ORDER_LINES_FRAGMENT = gql`
  fragment OrderLine on OrderLine {
    id
    quantity
    totalQuantity
    unitPrice
    featuredAsset {
      source
    }
    merchantVoluntaryRefund
    productVariant {
      id
      sku
      price
      name
      options {
        code
        name
      }
      featuredAsset {
        source
      }
      isThereAnyStock
      customFields {
        virtualTargetType
      }
      product {
        id
        name
        description
        enabled
        customFields {
          isVipProduct
          unit
        }
        featuredAsset {
          id
          width
          height
          name
          preview
          source
          type
        }
        customFields {
          price
          markingPrice
          unit
          limitType
          limitCount
          putOnSaleType
          putOnSaleTime
        }
      }
    }
    customFields {
      purchasePattern
      isAvailableAfterSale
      afterSaleLine {
        id
        createdAt
        updatedAt
        quantity
        price
      }
      afterSale {
        id
        cause
        state
        mode
      }
    }
  }
`;

/** 订单 - 项 */
export const ORDER_FRAGMENT = gql`
  fragment Order on Order {
    id
    createdAt
    updatedAt
    orderPlacedAt
    code
    state
    total
    totalQuantity
    isPaymentRewardActivity
    customFields {
      subscriptionPlan {
        ...SubscriptionPlan
      }
      subscription {
        id
        expireNumberOfPeriod
      }
      periods
      deliveryInterval
      firstShippingDate
      isAvailableAfterSale
      timeoutPeriodToBePaid
      timeoutPeriodToBeReceived
      remark
      orderPromotionResult {
        promResult {
          orderTotalPrice
        }
      }
    }
    fulfillments {
      id
      createdAt
      method
    }
    lines {
      ...OrderLine
    }
    surcharges {
      id
      price
    }
    shipping
    shippingAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      province
      postalCode
      country
      countryCode
      phoneNumber
      customFields {
        district
      }
    }
  }
  ${ORDER_LINES_FRAGMENT}
  ${SUBSCRIPTIONPLAN_FRAGMENT}
`;
